import { selectTermNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { loadIncomingReferences } from '@newStore/externalData/externalDataState';
import { NodeType, RequiredType, type RootNodeConfig } from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { imageComponentBase } from '@nodeTypeConfig/helpers/editComponents/imageComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { settings } from '../../settings';

const TERM: RootNodeConfig = {
  nodeSelector: selectTermNode,
  information: {
    definiteArticle: true,
    single: 'Begrip',
    plural: 'Begrippen',
    icon: require('../../../../img/icons/term.svg'),
  },
  websiteHref: null,
  onLoadActions: [loadIncomingReferences()],
  createModal: {
    authors: {
      addUser: true,
    },
  },
  edit: [
    titleComponent,
    {
      ...descriptionComponent,
      required: RequiredType.ERROR,
    },
    publishComponent,
    authorsComponent,
    {
      ...imageComponentBase,
      label: 'Miniatuur',
      options: {
        type: 'THUMBNAIL',
      },
    },
  ],
  buildingBlocks: [{ type: NodeType.PARAGRAPH }, { type: NodeType.IMAGE }],
  tocTypes: [],
  isCreatable: true,
  isSearchable: true,
  allowSuggestions: false,
  customEditorOptions: {
    hideTermButton: true,
  },
  previewModes: [
    {
      type: 'ZILL',
      name: 'Zill Leerplansite',
      location: `${settings.apisAndUrls.zill}/#!/bib/begrippen/{%key}?preview&version={%version}`,
    },
  ],
};

export default TERM;
